import { Pc, FungibleConditionCode } from '@stacks/transactions'
import { STACKS_NETWORK_TYPE } from '../config/stacks'
import { TokenName } from '../enums/tokens'
import { Token } from '../interfaces/tokens'

const applyCondition = (builder: any, conditionCode: FungibleConditionCode, amount: number) => {
  switch (conditionCode) {
    case FungibleConditionCode.Equal: return builder.willSendEq(amount)
    case FungibleConditionCode.GreaterEqual: return builder.willSendGte(amount)
    case FungibleConditionCode.Greater: return builder.willSendGt(amount)
    case FungibleConditionCode.LessEqual: return builder.willSendLte(amount)
    case FungibleConditionCode.Less: return builder.willSendLt(amount)
    default: return builder.willSendEq(amount)
  }
}

const getTokenFtArgs = (token: Token): { contractId: string; assetName: string } => {
  const contract = token.contract[STACKS_NETWORK_TYPE]
  if (!contract) {
    throw new Error(`Contract details for token '${token.name}' on ${STACKS_NETWORK_TYPE} are missing`)
  }
  return {
    contractId: `${contract.address}.${contract.name}`,
    assetName: contract.asset
  }
}

export const createUserPostCondition = (address: string, conditionCode: FungibleConditionCode, amount: number, token: Token) => {
  const builder = applyCondition(Pc.principal(address), conditionCode, amount)

  if (token.name === TokenName.STX) {
    return builder.ustx()
  }

  const { contractId, assetName } = getTokenFtArgs(token)
  return builder.ft(contractId, assetName)
}

export const createContractPostCondition = (address: string, contractName: string, conditionCode: FungibleConditionCode, amount: number, token: Token) => {
  const builder = applyCondition(Pc.principal(`${address}.${contractName}`), conditionCode, amount)

  if (token.name === TokenName.STX) {
    return builder.ustx()
  }

  const { contractId, assetName } = getTokenFtArgs(token)
  return builder.ft(contractId, assetName)
}
